export const SET_SURVEYS = 'SET_SURVEYS';
export const SET_SURVEY = 'SET_SURVEY';
export const SET_SURVEY_QUESTIONS = 'SET_SURVEY_QUESTIONS';
export const SET_OPTIONS = 'SET_OPTIONS';
export const DOWNLOAD_REPORT = 'DOWNLOAD_REPORT';
export const CLEAR_SURVEYS = 'CLEAR_SURVEYS';
export const CANDIDATE_QUESTIONS = 'CANDIDATE_QUESTIONS';
export const SET_CONDITION = 'SET_CONDITION';
export const UNLINK_CONDITION = 'UNLINK_CONDITION';
